import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import { authentication } from './services/Authentication';
import { createBrowserHistory } from 'history';
import helpers from './Function';

import Dashboard from "./component/Dashboard";
import Login from "./component/Login";
import Member from "./component/Member";
import Worksheet from "./component/Worksheet";
import HomeType from "./component/HomeType";
import ProjectType from "./component/ProjectType";
import ProjectHome from "./component/ProjectHome";
import MainService from "./component/MainService";
import SubService from "./component/SubService";
import Residence from "./component/Residence";
import Users from "./component/Users";
import ReportHomecare from "./component/ReportHomecare";
import ReportJuristics from "./component/ReportJuristics";
import ReportPresale from "./component/ReportPresale";

import Header from "./component/Header";
import MenuLeft from "./component/MenuLeft";
import Footer from "./component/Footer";
import JuristicWorksheet from './component/JuristicWorksheet';
import JuristicMainService from './component/JuristicMainService';
import JuristicSubService from './component/JuristicSubService';
import PrivilegeMGM from './component/PrivilegeMGM';
import PrivilegeEvent from './component/PrivilegeEvent';
import PrivilegePoint from './component/PrivilegePoint';
import PrivilegePointHistory from './component/PrivilegePointHistory';
import BeyondService from './component/BeyondService';
import BlogNews from './component/BlogNews';
import SystemAdminPermission from './component/SystemAdminPermission';
import TipsSubCategory from './component/TipsSubCategory';
import TipsMainCategory from './component/TipsMainCategory';
import Tips from './component/Tips';
import Chat from './component/Chat';
import ChatRoom from './component/Chatroom';
import BannerHome from './component/BannerHome';
import BannerPromotion from './component/BannerPromotion';
import HouseProgress from './component/HouseProgress';
import ProjectDetail from './component/ProjectDetail';
import TrackingData from './component/TrackingData';
import Notification from './component/Notification';
import AboutUs from './component/AboutUs';
import ContactUs from './component/ContactUs';
import Policy from './component/Policy';
import PaymentAmount from './component/PaymentAmount';
import Register from './component/Register';
import RegisterMGM from './component/RegisterMGM';
import MemberGuest from './component/MemberGuest';
import MemberResident from './component/MemberResident';
import Regulation from './component/Regulation';
import ServiceFee from './component/ServiceFee';
import OverviewFee from './component/OverviewFee';
import EmergencyCall from './component/EmergencyCall';
import MailandParcel from './component/MailandParcel';
import PresaleContact from './component/PresaleContact';
import PresaleRegister from './component/PresaleRegister';
import PresalePromotion from './component/PresalePromotion';
import PrivilegeEventRegister from './component/PrivilegeEventRegister';
import PrivilegeEventTransaction from './component/PrivilegeEventTransaction';
import PolicyTracking from './component/PolicyTracking';
import MemberApprove from './component/MemberApprove';
import CommunityNew from './component/CommunityNew';
import JuristicMessageBox from './component/JuristicMessageBox';
import MemberNirvana from './component/membernirvana';
import PolicyTrackingPresale from './component/PolicyTrackingPresale';
import MemberAuto from './component/MemberAuto';
import GroupService from './component/GroupService';
import JuristicGroupService from './component/JuristicGroupService';
import MemberLogs from './component/Memberlogs';
import ConfigEmail from './component/ConfigEmail';
import MemberDelete from './component/MemberDelete';

//callcenter
import MyCase from "./component/callcenter/MyCase";
import DoneCase from "./component/callcenter/DoneCase";
import AllCase from "./component/callcenter/AllCase";
import CustomerProfile from "./component/callcenter/CustomerProfile";
import CustomerHistory from "./component/callcenter/CustomerHistory";
import NewForm from "./component/callcenter/NewForm";
import DetailCase from "./component/callcenter/DetailCase";
import CallcenterWorksheet from './component/CallcenterWorksheet';
import CallcenterMainService from './component/CallcenterMainService';
import CallcenterSubService from './component/CallcenterSubService';
import CallcenterGroupService from './component/CallcenterGroupService';

// import Consent from './component/Consent';
import CategoryPoint from './component/CategoryPoint';
import CategoryPrivilege from './component/CategoryPrivilege';
import CategoryTransfer from './component/CategoryTransfer';
import HistoryPoint from './component/HistoryPoint';
import HistoryPrivilege from './component/HistoryPrivilege';
import HistoryTransfer from './component/HistoryTransfer';
import TypePoint from './component/TypePoint';
import Point from './component/Point';
import TransferPoint from './component/TransferPoint';
import LevelMember from './component/LevelMember';
import Referral from './component/Referral';
import Privilege from './component/Privilege';
import MemberPointTransaction from './component/MemberPointTransaction';
import MemberPointApprove from './component/MemberPointApprove';
import MGMTransaction from './component/MGMTransaction';
import MemberCancel from './component/MemberCancel';
import NotFoundPage from './component/PageNotFound';
import RegisterFGF from './component/RegisterFGF';
//callcenter
// import MyCase from "./component/callcenter/MyCase";
// import DoneCase from "./component/callcenter/DoneCase";
// import AllCase from "./component/callcenter/AllCase";
// import CustomerProfile from "./component/callcenter/CustomerProfile";
// import CustomerHistory from "./component/callcenter/CustomerHistory";
// import NewForm from "./component/callcenter/NewForm";
// import DetailCase from "./component/callcenter/DetailCase";

export default class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentUser: null,
    };

  }

  componentDidMount() {
    authentication.currentUser.subscribe(x => this.setState({ currentUser: x }));
  }

  logout() {
    authentication.logout();
    createBrowserHistory.push('/login');
  }

  render() {
    const currentUser = authentication.currentUserValue;
    var miss_suc = false;
    var miss_su = false;
    var miss_acc = false;

    if (currentUser) {
      const { user_type } = currentUser;
      miss_suc = helpers.getUserType(user_type, "suc");
      miss_su = helpers.getUserType(user_type, "su");
      miss_acc = helpers.getUserType(user_type, "acc");

    }

    return (
      <Router>
        <Switch>
          <Route path="/" exact render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><Dashboard /><Footer /></div>
            }
          }
          } />

          <Route path="/paymentamount" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><PaymentAmount /><Footer /></div>
            }
          }
          } />

          <Route path="/communitynews" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><CommunityNew /><Footer /></div>
            }
          }
          } />

          <Route path="/messagebox" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><JuristicMessageBox /><Footer /></div>
            }
          }
          } />

          {
            <Route path="/member" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><Member /><Footer /></div>
              }
            }
            } />
          }

          {
            <Route path="/memberguest" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><MemberGuest /><Footer /></div>
              }
            }
            } />
          }

          {
            <Route path="/memberresident" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><MemberResident /><Footer /></div>
              }
            }
            } />
          }

          {
            <Route path="/memberapprove" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><MemberApprove /><Footer /></div>
              }
            }
            } />
          }

          {
            <Route path="/memberproperty" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><MemberNirvana /><Footer /></div>
              }
            }
            } />
          }

          {
            <Route path="/memberlogs" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><MemberLogs /><Footer /></div>
              }
            }
            } />
          }

          {
            <Route path="/membercancel" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><MemberCancel /><Footer /></div>
              }
            }
            } />
          }

          {
            <Route path="/memberdelete" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><MemberDelete /><Footer /></div>
              }
            }
            } />
          }

          {
            <Route path="/memberauto" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><MemberAuto /><Footer /></div>
              }
            }
            } />
          }

          <Route path="/paymentamount" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><PaymentAmount /><Footer /></div>
            }
          }
          } />

          <Route path="/worksheet" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><Worksheet /><Footer /></div>
            }
          }
          } />

          <Route path="/callcenterworksheet" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><CallcenterWorksheet /><Footer /></div>
            }
          }
          } />

          {
            <Route path="/hometype" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><HomeType /><Footer /></div>
              }
            }
            } />
          }

          {
            <Route path="/projecttype" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><ProjectType /><Footer /></div>
              }
            }
            } />
          }

          <Route path="/projecthome" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><ProjectHome /><Footer /></div>
            }
          }
          } />

          {
            <Route path="/mainservice" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><MainService /><Footer /></div>
              }
            }
            } />
          }

          {
            <Route path="/callcentermainservice" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><CallcenterMainService /><Footer /></div>
              }
            }
            } />
          }

          {
            <Route path="/subservice" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><SubService /><Footer /></div>
              }
            }
            } />
          }

          {
            <Route path="/callcentersubservice" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><CallcenterSubService /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/groupservice" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><GroupService /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/callcentergroupservice" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><CallcenterGroupService /><Footer /></div>
              }
            }
            } />
          }
          <Route path="/residence" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><Residence /><Footer /></div>
            }
          }
          } />

          {<Route path="/users" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><Users /><Footer /></div>
            }
          }
          } />
          }

          <Route path="/reporthomecare" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><ReportHomecare /><Footer /></div>
            }
          }
          } />

          <Route path="/reportjuristic" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><ReportJuristics /><Footer /></div>
            }
          }
          } />

          <Route path="/reportpresale" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><ReportPresale /><Footer /></div>
            }
          }
          } />

          <Route path="/juristicworksheet" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft /><JuristicWorksheet /><Footer /></div>
            }
          }
          } />

          {
            <Route path="/juristicmainservice" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><JuristicMainService /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/juristicgroupservice" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><JuristicGroupService /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/juristicsubservice" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><JuristicSubService /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/privilegemgm" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><PrivilegeMGM /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/privilegeevent" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><PrivilegeEvent /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/privilegepoint" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><PrivilegePoint /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/privilegepointhistory" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><PrivilegePointHistory /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/beyondservice" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><BeyondService /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/blogs" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><BlogNews /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/subcategory" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><TipsSubCategory /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/maincategory" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><TipsMainCategory /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/tips" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><Tips /><Footer /></div>
              }
            }
            } />
          }
          {/* {
            <Route path="/chatpage" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><Chat /><Footer /></div>
              }

            }
            } />
          } */}
          {/* {
            <Route path="/chatroom" render={props => {
              return <div><Header /><MenuLeft /><ChatRoom /><Footer /></div>
            }
            } />
          } */}
          {
            <Route path="/permission" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><SystemAdminPermission /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/bannerhome" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><BannerHome /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/bannerpromotion" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><BannerPromotion /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/houseprogress" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><HouseProgress /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/projectdetail" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><ProjectDetail /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/trackingdata" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><TrackingData /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/notification" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><Notification /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/aboutus" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><AboutUs /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/contactus" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><ContactUs /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/configemail" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><ConfigEmail /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/policy" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><Policy /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/regulation" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><Regulation /><Footer /></div>
              }
            }
            } />
          }
          {/* {
            <Route path="/servicefee" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><ServiceFee /><Footer /></div>
              }
            }
            } />
          } */}
          {
            <Route path="/overviewfee" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><OverviewFee /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/emergencycall" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><EmergencyCall /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/mailandparcel" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><MailandParcel /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/presalecontact" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><PresaleContact /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/presaleregister" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><PresaleRegister /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/presalepromotion" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><PresalePromotion /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/privilegeeventregister" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><PrivilegeEventRegister /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/privilegeeventtransaction" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><PrivilegeEventTransaction /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/policytracking" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><PolicyTracking /><Footer /></div>
              }
            }
            } />
          }
          {
            <Route path="/policytrackingpresale" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft /><PolicyTrackingPresale /><Footer /></div>
              }
            }
            }
            />
          }

          //callcenter

          <Route path="/my-case" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <MyCase />
                <Footer />
              </div>
            }
          }
          } />
          <Route path="/all-case" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <AllCase />
                <Footer />
              </div>
            }
          }
          } />

          <Route path="/done-case" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <DoneCase />
              </div>
            }
          }
          } />

          <Route path="/customer-profile" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <CustomerProfile />
                <Footer />
              </div>
            }
          }
          } />

          <Route path="/customer-history" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <CustomerHistory />
                <Footer />
              </div>
            }
          }
          } />

          <Route path="/new-form" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <NewForm />
                <Footer />
              </div>
            }
          }
          } />

          <Route path="/detail-case/:id" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <DetailCase id={props.match.params.id} />
                <Footer />
              </div>
            }
          }
          } />

          {/* <Route path="/consent" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <Consent />
                <Footer />
              </div>
            }
          }
          } /> */}

          <Route path="/category-point" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <CategoryPoint />
                <Footer />
              </div>
            }
          }
          } />
          
          <Route path="/category-type" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <TypePoint />
                <Footer />
              </div>
            }
          }
          } />

          <Route path="/category-privilege" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <CategoryPrivilege />
                <Footer />
              </div>
            }
          }
          } />

          <Route path="/category-transfer" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <CategoryTransfer />
                <Footer />
              </div>
            }
          }
          } />

          <Route path="/history-point" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <HistoryPoint />
                <Footer />
              </div>
            }
          }
          } />

          <Route path="/history-privilege" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <HistoryPrivilege />
                <Footer />
              </div>
            }
          }
          } />

          <Route path="/history-transfer" render={props => {
            if (!currentUser) {
              return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            } else {
              return <div><Header /><MenuLeft />
                <HistoryTransfer />
                <Footer />
              </div>
            }
          }
          } />

          <Route path="/point" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft />
                  <Point />
                  <Footer />
                </div>
              }
            }
          } />

          <Route path="/transferpoint" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft />
                  <TransferPoint />
                  <Footer />
                </div>
              }
            }
          } />

          <Route path="/memberpointtransaction" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft />
                  <MemberPointTransaction />
                  <Footer />
                </div>
              }
            }
          } />

          <Route path="/memberpointapprove" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft />
                  <MemberPointApprove />
                  <Footer />
                </div>
              }
            }
          } />

          <Route path="/mgmtransaction" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft />
                  <MGMTransaction />
                  <Footer />
                </div>
              }
            }
          } />

          <Route path="/level-member" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft />
                  <LevelMember />
                  <Footer />
                </div>
              }
            }
          } />

          <Route path="/referral" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft />
                  <Referral />
                  <Footer />
                </div>
              }
            }
          } />

          <Route path="/privilege" render={props => {
              if (!currentUser) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
              } else {
                return <div><Header /><MenuLeft />
                  <Privilege />
                  <Footer />
                </div>
              }
            }
          } />

          <Route path="/login" component={Login} />
          <Route path="/register" component={Register} />
          <Route path="/registermgm" component={RegisterFGF} />


          <Route path="*" render={props => {
            return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
          }} />
        </Switch>
      </Router>
    );
  }
}
